import { Card, Col, PageHeader, Row } from "antd";
import { TeamOutlined, OrderedListOutlined } from "@ant-design/icons";
import React, { Component } from "react";

const OPCIONES = [
  {
    key: "integracionClientes",
    titulo: "Integración de Clientes",
    descripcion:
      "Consulta las facturas agrupadas por cliente, con sus totales y pendientes de pago.",
    icono: <TeamOutlined />,
    color: "#5A4FCC",
    ruta: "integracionClientes",
    disabled: false,
  },
  {
    key: "consecutivo",
    titulo: "Consecutivo",
    descripcion:
      "Consulta las facturas en una sola lista ordenada por número de facturación.",
    icono: <OrderedListOutlined />,
    color: "#1677FF",
    ruta: "consecutivo",
    disabled: false,
  },
];

class ReporteFacturacion extends Component {
  atras() {
    this.props.history.goBack();
  }

  seleccionar(opcion) {
    if (opcion.disabled) return;
    this.props.history.push(`${this.props.match.url}/${opcion.ruta}`);
  }

  render() {
    return (
      <>
        <PageHeader
          onBack={this.atras.bind(this)}
          title="Facturación"
          style={{
            border: "1px solid rgb(235, 237, 240)",
            backgroundColor: "white",
            marginBottom: 10,
          }}
        />
        <Row gutter={16}>
          {OPCIONES.map((opcion) => (
            <Col span={8} key={opcion.key}>
              <Card
                hoverable={!opcion.disabled}
                onClick={() => this.seleccionar(opcion)}
                style={{
                  textAlign: "center",
                  height: 220,
                  opacity: opcion.disabled ? 0.55 : 1,
                  cursor: opcion.disabled ? "not-allowed" : "pointer",
                  borderTop: `3px solid ${opcion.color}`,
                  boxShadow: "0 4px 14px rgba(0,0,0,0.08)",
                }}
                bodyStyle={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  height: "100%",
                }}
              >
                <div style={{ fontSize: 36, color: opcion.color, marginBottom: 10 }}>
                  {opcion.icono}
                </div>
                <h2 style={{ fontSize: 16, marginBottom: 6 }}>{opcion.titulo}</h2>
                <p style={{ fontSize: 12, color: "#666", margin: 0 }}>
                  {opcion.descripcion}
                </p>
              </Card>
            </Col>
          ))}
        </Row>
      </>
    );
  }
}

export default ReporteFacturacion;
